<template>
  <div class="student-info-panel"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="basicInfo">
      <div class="main"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="main-cont">
          <AppScrollbar style="height: 100%">
            <div class="info-main">
              <TitleGroup fold
                          :edit-mode="isEditable">
                <template #title>
                  <i class="el-icon-user"></i>
                  <span class="title">基本信息</span>
                </template>
                <div class="info-wrap">
                  <el-form size="mini"
                           label-width="80px"
                           label-suffix="：">
                    <el-row type="flex"
                            :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="姓名">
                          <div class="value">{{basicInfo.trueName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="性别">
                          <div class="value">{{basicInfo.genderName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="出生日期">
                          <div class="value">{{basicInfo.birthDate}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="籍贯">
                          <div class="value">{{basicInfo.fromOrigin}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="民族">
                          <div class="value">{{basicInfo.folkName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="政治面貌">
                          <div class="value">{{basicInfo.polityName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="证件类型">
                          <div class="value">{{basicInfo.idCardTypeName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="证件号码">
                          <div class="value">{{basicInfo.idCard}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="工作单位">
                          <div class="value">{{basicInfo.workUnit}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="单位性质">
                          <div class="value">{{basicInfo.workUnitTypeName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="职务">
                          <div class="value">{{basicInfo.jobDuty}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="职称">
                          <div class="value">{{basicInfo.jobTitleName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="所属行业">
                          <div class="value">{{basicInfo.industryName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="工作职能">
                          <div class="value">{{basicInfo.jobFunctionName}}</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <template #edit>
                  <div class="info-wrap">
                    <el-form size="mini"
                             label-width="80px"
                             label-suffix="：">
                      <el-row type="flex"
                              :gutter="20">
                        <el-col :span="8">
                          <el-form-item label="姓名"
                                        class="required">
                            <el-input v-model="form.trueName"
                                      size="mini"
                                      type="text"
                                      maxlength="50"
                                      placeholder="请输入姓名"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="性别"
                                        class="required">
                            <el-select v-model="form.genderCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择性别">
                              <template v-if="editInfo && editInfo.genderList">
                                <el-option v-for="gender in editInfo.genderList"
                                           :key="gender.code"
                                           :label="gender.name"
                                           :value="gender.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="出生日期">
                            <el-date-picker v-model="form.birthDate"
                                            size="mini"
                                            type="date"
                                            prefix-icon="el-icon-date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择出生日期"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="籍贯">
                            <el-input v-model="form.fromOrigin"
                                      size="mini"
                                      type="text"
                                      maxlength="100"
                                      placeholder="请输入籍贯"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="民族"
                                        class="required">
                            <el-select v-model="form.folkCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择民族">
                              <template v-if="editInfo && editInfo.folkList">
                                <el-option v-for="folk in editInfo.folkList"
                                           :key="folk.code"
                                           :label="folk.name"
                                           :value="folk.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="政治面貌"
                                        class="required">
                            <el-select v-model="form.polityCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择政治面貌">
                              <template v-if="editInfo && editInfo.polityList">
                                <el-option v-for="polity in editInfo.polityList"
                                           :key="polity.code"
                                           :label="polity.name"
                                           :value="polity.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="证件类型"
                                        class="required">
                            <el-select v-model="form.idCardTypeCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择证件类型">
                              <template v-if="editInfo && editInfo.idCardTypeList">
                                <el-option v-for="idCardType in editInfo.idCardTypeList"
                                           :key="idCardType.code"
                                           :label="idCardType.name"
                                           :value="idCardType.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="证件号码"
                                        class="required">
                            <el-input v-model="form.idCard"
                                      size="mini"
                                      type="text"
                                      maxlength="50"
                                      placeholder="请输入证件号码"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="工作单位"
                                        class="required">
                            <el-input v-model="form.workUnit"
                                      size="mini"
                                      type="text"
                                      maxlength="100"
                                      placeholder="请输入工作单位"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="单位性质">
                            <el-select v-model="form.workUnitTypeCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择单位性质">
                              <template v-if="editInfo && editInfo.workUnitTypeList">
                                <el-option v-for="workUnitType in editInfo.workUnitTypeList"
                                           :key="workUnitType.code"
                                           :label="workUnitType.name"
                                           :value="workUnitType.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="职务"
                                        class="required">
                            <el-input v-model="form.jobDuty"
                                      size="mini"
                                      type="text"
                                      maxlength="100"
                                      placeholder="请输入职务"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="职称"
                                        class="required">
                            <el-select v-model="form.jobTitleCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择职称">
                              <template v-if="editInfo && editInfo.jobTitleList">
                                <el-option v-for="jobTitle in editInfo.jobTitleList"
                                           :key="jobTitle.code"
                                           :label="jobTitle.name"
                                           :value="jobTitle.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="所属行业">
                            <el-select v-model="form.industryCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择所属行业">
                              <template v-if="editInfo && editInfo.industryList">
                                <el-option v-for="industry in editInfo.industryList"
                                           :key="industry.code"
                                           :label="industry.name"
                                           :value="industry.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="工作职能">
                            <el-select v-model="form.jobFunctionCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择工作职能">
                              <template v-if="editInfo && editInfo.jobFunctionList">
                                <el-option v-for="jobFunction in editInfo.jobFunctionList"
                                           :key="jobFunction.code"
                                           :label="jobFunction.name"
                                           :value="jobFunction.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </template>
              </TitleGroup>
              <TitleGroup fold
                          :edit-mode="isEditable">
                <template #title>
                  <i class="el-icon-phone-outline"></i>
                  <span class="title">联系方式</span>
                </template>
                <div class="info-wrap">
                  <el-form size="mini"
                           label-width="80px"
                           label-suffix="：">
                    <el-row type="flex"
                            :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="手机号码">
                          <div class="value">{{basicInfo.mobilePhone}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="联系电话">
                          <div class="value">{{basicInfo.phone}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="家庭邮编">
                          <div class="value">{{basicInfo.zipCode}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="电子邮箱">
                          <div class="value">{{basicInfo.email}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="地址">
                          <div class="value">{{basicInfo.address}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="所在地市">
                          <div class="value">{{basicInfo.fromRegionName}}</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <template #edit>
                  <div class="info-wrap">
                    <el-form size="mini"
                             label-width="80px"
                             label-suffix="：">
                      <el-row type="flex"
                              :gutter="20">
                        <el-col :span="8">
                          <el-form-item label="手机号码"
                                        class="required">
                            <el-input v-model="form.mobilePhone"
                                      size="mini"
                                      type="text"
                                      maxlength="20"
                                      placeholder="请输入手机号码"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="联系电话">
                            <el-input v-model="form.phone"
                                      size="mini"
                                      type="text"
                                      maxlength="20"
                                      placeholder="请输入联系电话"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="家庭邮编">
                            <el-input v-model="form.zipCode"
                                      size="mini"
                                      type="text"
                                      maxlength="6"
                                      placeholder="请输入家庭邮编"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="电子邮箱">
                            <el-input v-model="form.email"
                                      size="mini"
                                      type="text"
                                      maxlength="200"
                                      placeholder="请输入电子邮箱"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="地址">
                            <el-input v-model="form.address"
                                      size="mini"
                                      type="text"
                                      maxlength="200"
                                      placeholder="请输入地址"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="所在地市">
                            <el-select v-model="form.fromRegionCode"
                                       size="mini"
                                       filterable
                                       clearable
                                       placeholder="请选择所在地市">
                              <template v-if="editInfo && editInfo.fromRegionList">
                                <el-option v-for="fromRegion in editInfo.fromRegionList"
                                           :key="fromRegion.code"
                                           :label="fromRegion.name"
                                           :value="fromRegion.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </template>
              </TitleGroup>
              <TitleGroup fold
                          :edit-mode="isEditable">
                <template #title>
                  <i class="el-icon-document-checked"></i>
                  <span class="title">录取信息</span>
                </template>
                <div class="info-wrap">
                  <el-form size="mini"
                           label-width="80px"
                           label-suffix="：">
                    <el-row type="flex"
                            :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="班级">
                          <div class="value">{{basicInfo.clazz}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="学号">
                          <div class="value">{{basicInfo.regNo}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="教学点">
                          <div class="value">{{basicInfo.site}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="年级">
                          <div class="value">{{basicInfo.grade}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="学籍年级">
                          <div class="value">{{basicInfo.statusGrade}}</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <template #edit>
                  <div class="info-wrap">
                    <el-form size="mini"
                             label-width="80px"
                             label-suffix="：">
                      <el-row type="flex"
                              :gutter="20">
                        <el-col :span="8">
                          <el-form-item label="班级">
                            <div class="value">{{basicInfo.clazz}}</div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="学号">
                            <el-input v-model="form.regNo"
                                      size="mini"
                                      type="text"
                                      maxlength="50"
                                      placeholder="请输入学号"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="教学点">
                            <div class="value">{{basicInfo.site}}</div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="年级">
                            <div class="value">{{basicInfo.grade}}</div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="学籍年级">
                            <div class="value">{{basicInfo.statusGrade}}</div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </template>
              </TitleGroup>
              <TitleGroup fold
                          :edit-mode="isEditable">
                <template #title>
                  <i class="el-icon-collection"></i>
                  <span class="title">原毕业信息</span>
                </template>
                <div class="info-wrap">
                  <el-form size="mini"
                           label-width="80px"
                           label-suffix="：">
                    <el-row type="flex"
                            :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="最终学历">
                          <div class="value">{{basicInfo.degreeName}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="原毕业学校">
                          <div class="value">{{basicInfo.graduateSchool}}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="原就读专业">
                          <div class="value">{{basicInfo.graduateMajor}}</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <template #edit>
                  <div class="info-wrap">
                    <el-form size="mini"
                             label-width="80px"
                             label-suffix="：">
                      <el-row type="flex"
                              :gutter="20">
                        <el-col :span="8">
                          <el-form-item label="最终学历">
                            <el-select v-model="form.degreeCode"
                                       filterable
                                       clearable
                                       placeholder="请选择最终学历">
                              <template v-if="editInfo && editInfo.degreeList">
                                <el-option v-for="degree in editInfo.degreeList"
                                           :key="degree.code"
                                           :label="degree.name"
                                           :value="degree.code"/>
                              </template>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="原毕业学校">
                            <el-input v-model="form.graduateSchool"
                                      type="text"
                                      maxlength="100"
                                      placeholder="请输入原毕业学校"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="原就读专业">
                            <el-input v-model="form.graduateMajor"
                                      type="text"
                                      maxlength="100"
                                      placeholder="请输入原就读专业"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </template>
              </TitleGroup>
              <TitleGroup fold
                          :edit-mode="isEditable">
                <template #title>
                  <i class="el-icon-document-add"></i>
                  <span class="title">更多信息</span>
                </template>
                <div class="info-wrap">
                  <el-form size="mini"
                           label-width="80px"
                           label-suffix="：">
                    <el-row type="flex"
                            :gutter="20">
                      <el-col :span="24">
                        <el-form-item label="备注信息">
                          <div class="value pre">{{basicInfo.remark}}</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <template #edit>
                  <div class="info-wrap">
                    <el-form size="mini"
                             label-position="top"
                             label-suffix="：">
                      <el-row type="flex"
                              :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="备注信息">
                            <el-input v-model="form.remark"
                                      type="textarea"
                                      maxlength="500"
                                      show-word-limit
                                      placeholder="请填写备注信息"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </template>
              </TitleGroup>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div v-if="editable"
           class="footer">
        <template v-if="editMode">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="submitEdit">保存修改</el-button>
          <el-button size="mini"
                     type="default"
                     @click="quitEdit">取消编辑</el-button>
        </template>
        <template v-else>
          <el-button size="mini"
                     type="primary"
                     plain
                     :loading="editing"
                     @click="loadEditInfo">{{editing ? '加载中...' : '编辑信息'}}</el-button>
        </template>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <span>详情数据加载失败</span>
        <el-button type="text"
                   @click="loadBasicInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import Hint from '../../../../../../../elements/Hint'
import checkUtils from '../../../../../../../../util/checkUtils'
export default {
  name: 'StudentInfoPanel',
  components: {
    AppScrollbar,
    TitleGroup,
    Hint
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    editable: Boolean,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      basicInfo: null,
      editing: false,
      editInfo: null,
      editMode: false,
      form: {
        trueName: '',
        genderCode: '',
        birthDate: '',
        fromOrigin: '',
        folkCode: '',
        polityCode: '',
        idCardTypeCode: '',
        idCard: '',
        workUnit: '',
        workUnitTypeCode: '',
        industryCode: '',
        jobFunctionCode: '',
        jobDuty: '',
        jobTitleCode: '',
        mobilePhone: '',
        phone: '',
        zipCode: '',
        email: '',
        address: '',
        fromRegionCode: '',
        degreeCode: '',
        graduateSchool: '',
        graduateMajor: '',
        remark: '',
        regNo: ''
      },
      committing: false
    }
  },
  computed: {
    isEditable () {
      return this.editable && this.editMode
    }
  },
  methods: {
    loadBasicInfo () {
      this.$emit('start-refresh')
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/student/info/basic',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.basicInfo = response.data['basicInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        this.$emit('end-refresh')
      })
    },
    loadEditInfo () {
      if (this.editInfo) {
        this.editMode = true
      } else {
        this.editing = true
        this.$ajax({
          url: '/workspace/manager/portal/student/info/edit',
          method: 'post'
        }).then(response => {
          if (response.data) {
            this.editInfo = response.data['editInfo'] || {}
            this.$nextTick(() => {
              this.editMode = true
            })
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.editing = false
        })
      }
    },
    quitEdit () {
      this.editMode = false
    },
    submitEdit () {
      if (!this.form.trueName) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!this.form.genderCode) {
        this.$message.warning('请选择性别')
        return
      }
      if (!this.form.folkCode) {
        this.$message.warning('请选择民族')
        return
      }
      if (!this.form.polityCode) {
        this.$message.warning('请选择政治面貌')
        return
      }
      if (!this.form.idCardTypeCode) {
        this.$message.warning('请选择证件类型')
        return
      }
      if (!this.form.idCard) {
        this.$message.warning('请输入证件号码')
        return
      }
      if (this.form.idCardTypeCode === '1') {
        if (!checkUtils.isIdCard(this.form.idCard)) {
          this.$message.warning('身份证号不合法')
          return
        }
      }
      if (!this.form.workUnit) {
        this.$message.warning('请输入工作单位')
        return
      }
      if (!this.form.jobDuty) {
        this.$message.warning('请输入职务')
        return
      }
      if (!this.form.jobTitleCode) {
        this.$message.warning('请选择职称')
        return
      }
      if (!this.form.mobilePhone) {
        this.$message.warning('请输入手机号码')
        return
      }
      if (!checkUtils.isMobilePhone(this.form.mobilePhone)) {
        this.$message.warning('手机号码不合法')
        return
      }
      if (this.form.phone) {
        if (!checkUtils.isPhone(this.form.phone)) {
          this.$message.warning('联系电话不合法')
          return
        }
      }
      if (this.form.zipCode) {
        if (!checkUtils.isZipCode(this.form.zipCode)) {
          this.$message.warning('家庭邮编不合法')
          return
        }
      }
      if (!this.form.regNo) {
        this.$message.warning('请输入学号')
        return
      }
      this.$confirm('确定要提交保存学生信息吗？', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/portal/student/info/submit',
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.studentId,
            submitInfo: JSON.stringify({
              basic: this.form
            })
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$emit('info-update')
                this.$nextTick(() => {
                  this.loadBasicInfo()
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.loadBasicInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadBasicInfo()
      }
    },
    editMode (val) {
      if (val) {
        const basicInfo = this.basicInfo
        if (basicInfo) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = basicInfo[key] || ''
          })
        }
      }
    },
    basicInfo () {
      this.editMode = false
    }
  }
}
</script>

<style lang="scss">
  .student-info-panel {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .info-main {
          padding: 15px;
          .title-group {
            &:last-child {
              .info-wrap {
                .vxe-table {
                  padding-bottom: 0;
                }
              }
            }
            &.edit-mode {
              & > .main {
                .info-wrap {
                  .el-form {
                    margin-top: 12px;
                    &--label-top {
                      margin-top: 2px;
                    }
                    .el-form-item {
                      margin-bottom: 12px;
                    }
                  }
                }
              }
            }
            & > .main {
              margin-top: 0;
              .info-wrap {
                .el-form {
                  padding: 6px 0 4px 18px;
                  &--label-top {
                    .el-form-item {
                      .el-form-item__label {
                        padding-bottom: 2px;
                      }
                    }
                  }
                  .el-form-item {
                    margin-bottom: 4px;
                    &.required {
                      .el-form-item__label {
                        position: relative;
                        &:before {
                          content: '*';
                          position: absolute;
                          left: -10px;
                          color: #f56c6c;
                        }
                      }
                    }
                    .el-form-item__label {
                      color: #909399;
                      font-size: 12px;
                      text-align: left;
                      white-space: nowrap;
                    }
                    .el-form-item__content {
                      font-size: 12px;
                      .value {
                        color: #303133;
                        word-break: break-all;
                        word-wrap: break-word;
                        &.pre {
                          white-space: pre-wrap;
                        }
                        &:empty {
                          &:before {
                            content: '\002f';
                            color: #909399;
                          }
                        }
                      }
                      .el-input,
                      .el-select {
                        width: 200px;
                        max-width: 100%;
                      }
                    }
                  }
                  .el-row--flex {
                    flex-wrap: wrap;
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 50px;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
      .el-button {
        padding: 6px 20px;
      }
    }
  }
</style>
